import React, { useState, useEffect } from "react";
import {
  Stack,
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  Typography,
  InputLabel,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const HEALTH_STATUSES = ["All", "Well", "Acute", "Chronic", "At Risk", "Complex", "End of Life", "No Status"];
const SINCE_OPTIONS = ["All", "12+ Months", "9 Months", "6 Months", "3 Months", "<3 Months"];

/**
 * Barra de filtros para la tabla de Recall.
 * Search (debounced), healthStatus, since (timeSinceLastVisit).
 */
export default function RecallFilters({ filters, onFilterChange }) {
  const [searchInput, setSearchInput] = useState(filters.search || "");

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      onFilterChange({ ...filters, search: searchInput });
    }, 300);
    return () => clearTimeout(timer);
  }, [searchInput]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={1.5}
      alignItems={{ xs: "stretch", sm: "center" }}
      sx={{ flexWrap: "wrap" }}
    >
      {/* Search */}
      <TextField
        size="small"
        placeholder="Search patient..."
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ fontSize: 18, color: "text.secondary" }} />
              </InputAdornment>
            ),
          },
        }}
        sx={{
          minWidth: 200,
          "& .MuiOutlinedInput-root": { borderRadius: 2 },
        }}
      />

      {/* Health Status */}
      <FormControl size="small" sx={{ minWidth: 130 }}>
        <InputLabel sx={{ fontSize: "0.8rem" }}>Status</InputLabel>
        <Select
          value={filters.healthStatus || "All"}
          label="Status"
          onChange={(e) => onFilterChange({ ...filters, healthStatus: e.target.value })}
          sx={{ borderRadius: 2, fontSize: "0.8rem" }}
        >
          {HEALTH_STATUSES.map((s) => (
            <MenuItem key={s} value={s}>
              <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>{s}</Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Since (time since last visit) */}
      <FormControl size="small" sx={{ minWidth: 130 }}>
        <InputLabel sx={{ fontSize: "0.8rem" }}>Since</InputLabel>
        <Select
          value={filters.since || "All"}
          label="Since"
          onChange={(e) => onFilterChange({ ...filters, since: e.target.value })}
          sx={{ borderRadius: 2, fontSize: "0.8rem" }}
        >
          {SINCE_OPTIONS.map((v) => (
            <MenuItem key={v} value={v}>
              <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>{v}</Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
}
